module.exports = __webpack_public_path__ + "img/35.23f6bcae.jpg";